import { Crown } from "lucide-react";

export const MembershipBadge = ({ tier }) => {
  if (tier === "paid") {
    return (
      <span className="
        inline-flex items-center gap-1.5 px-3 py-1 
        bg-gradient-to-r from-[#D4A373] to-[#C49565] 
        text-white text-xs font-medium tracking-wide
        rounded-full shadow-sm
      ">
        <Crown size={12} /> Premium
      </span>
    );
  }
  return (
    <span className="
      inline-flex items-center gap-1.5 px-3 py-1 
      bg-[#F3F4F6] text-[#6B7280] 
      text-xs font-medium tracking-wide
      rounded-full
    ">
      Free
    </span>
  );
};
